module.exports = __webpack_public_path__ + "static/media/jimmy-johns.f7c3687e.svg";